/**
 * The tax rates a NEW item gets when whoever creates it names none: every
 * enabled rate the location flagged Default (Settings → Tax Rates).
 *
 * Why this exists: the tills tax a line ONLY by the item's own `taxRateIds`
 * (`tax_calculation_cubit.dart`; `computeOrderTaxes` online) — a rate's
 * `default` flag is never applied at ring-up. So an item created without
 * rates sells untaxed forever. Measured House of Pho, Oct 1–10 2026: ~$300 of
 * bar-catalog cocktails rang up with no tax because adoption created them with
 * no `taxRateIds`, while the location's only rate (Sales Tax 7.35%) was the
 * default. The management form already pre-fills the default for a new item;
 * every SERVER path that creates an item reads it from here.
 *
 * A creator that knows the item's rates (a copy, an import that names them)
 * uses those instead — this is only the answer to "none were named".
 */
export interface DefaultTaxRateFacts {
  readonly taxRateId?: number | null;
  readonly default?: boolean | null;
  readonly disabled?: boolean | null;
}

export function defaultTaxRateIds(rates: ReadonlyArray<DefaultTaxRateFacts>): number[] {
  const ids = new Set<number>();
  for (const rate of rates) {
    if (rate.default !== true || rate.disabled === true) continue;
    if (typeof rate.taxRateId === "number" && Number.isInteger(rate.taxRateId)) ids.add(rate.taxRateId);
  }
  return [...ids].sort((a, b) => a - b);
}
